import React from 'react';
import { classNames } from '../../utils/style';
import { DefaultBsComponent } from '../../types/module';

import { Header } from './Header';
import { Price } from './Price';
import { CTA } from './CTA';
import { Engagement } from './Engagement';
import { Feature } from './Feature';
import { FeatureList } from './FeatureList';
import { Highlight } from './Highlight';
import './PricingCard.scss';
import PricingCardContext from './PricingCardContext';
import { HighlightedBorder } from './HighlightedBorder';

export interface PricingHighlightProps extends DefaultBsComponent {
  isPopular?: boolean;
  isDisabled?: boolean;
  classNamePricingCard?: string;
}

const PrincingCardComponent = ({
  isPopular,
  children,
  className,
  classNamePricingCard,
  isDisabled = false,
}: PricingHighlightProps) => (
  <PricingCardContext.Provider value={{ isDisabled }}>
    <div
      className={classNames('PricingCard relative font-sans', className)}
    >
      <div
        className={classNames(
          'bg-neutral-1 py-24 px-24 rounded-18 h-full flex flex-col flex-grow justify-between',
          classNamePricingCard,
          isPopular &&
            'shadow-s border border-solid border-blue-101',
        )}
      >
        <div className="flex flex-col flex-grow">{children}</div>
      </div>
    </div>
  </PricingCardContext.Provider>
);

export const PricingCard = Object.assign(PrincingCardComponent, {
  Header,
  Price,
  CTA,
  FeatureList,
  Feature,
  Engagement,
  Highlight,
  HighlightedBorder,
});
